module.exports = __webpack_public_path__ + "img/dark_float_ico_half.a9d24dd1.png";